<template>
  <div class="page">
    <div class="header">
      <h2>功能进度管理</h2>

      <el-button type="primary" @click="openAdd(0)">
        添加一级分类
      </el-button>
    </div>

    <div class="tree-box">
      <el-tree
        :data="treeData"
        node-key="id"
        default-expand-all
        :props="defaultProps"
      >
      
        <span
          class="custom-tree-node"
          slot-scope="{ node, data }"
        >
      
          <div class="tree-item">
      
            <div class="left">
      
              <span>
                {{ data.name }}
              </span>
      
            </div>
      
            <!-- <div class="center">
      
              <div>
                UI：{{ data.ui_progress }}%
              </div>
      
              <div>
                安卓：{{ data.android_progress }}%
              </div>
      
              <div>
                后端：{{ data.backend_progress }}%
              </div>
      
            </div> -->
      
            <div class="right">
      
              <el-button
                size="mini"
                type="primary"
                @click="openAdd(data.id)"
              >
                添加子级
              </el-button>
      
            </div>
      
          </div>
      
        </span>
      
      </el-tree>
    </div>

    <!-- 添加 -->
    <el-dialog
      title="添加功能"
      :visible.sync="dialogVisible"
      width="600px"
    >

      <el-form
        :model="form"
        label-width="120px"
      >

        <el-form-item label="功能名称">
          <el-input
            v-model="form.name"
            placeholder="请输入功能名称"
          />
        </el-form-item>

        <el-form-item label="图片地址">
          <el-input
            v-model="form.img"
            placeholder="请输入图片地址"
          />
        </el-form-item>

        <!-- <el-form-item label="UI完成度">
          <el-slider
            v-model="form.ui_progress"
            :max="100"
          />
        </el-form-item>

        <el-form-item label="安卓完成度">
          <el-slider
            v-model="form.android_progress"
            :max="100"
          />
        </el-form-item>

        <el-form-item label="后端完成度">
          <el-slider
            v-model="form.backend_progress"
            :max="100"
          />
        </el-form-item> -->

      </el-form>

      <div slot="footer">
        <el-button @click="dialogVisible = false">
          取消
        </el-button>

        <el-button
          type="primary"
          @click="submitForm"
        >
          确定
        </el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {

      treeData: [],

      defaultProps: {
        children: "children",
        label: "name"
      },

      dialogVisible: false,

      form: {
        parent_id: 0,
        name: "",
        img: "",
        ui_progress: 0,
        android_progress: 0,
        backend_progress: 0
      }

    };
  },

  created() {
    this.getList();
  },

  methods: {

    // 获取树形列表
    async getList() {

      const res = await axios.post(
        "https://tossp.yoooooo.com/index.php/index/tongji/getStatisticsTree"
      );

      this.treeData = res.data.data || [];
    },

    // 打开添加
    openAdd(parentId) {

      this.form = {
        parent_id: parentId,
        name: "",
        img: "",
        ui_progress: 0,
        android_progress: 0,
        backend_progress: 0
      };

      this.dialogVisible = true;
    },

    // 提交
    async submitForm() {

      if (!this.form.name) {
        this.$message.error("请输入名称");
        return;
      }

      const res = await axios.post(
        "https://tossp.yoooooo.com/index.php/index/tongji/addStatistics",
        this.form
      );

      if (res.data.code == 200) {

        this.$message.success("添加成功");

        this.dialogVisible = false;

        this.getList();

      } else {

        this.$message.error(res.data.msg);

      }

    }

  }
};
</script>

<style scoped>

.page{
  padding:20px;
}

.header{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:20px;
}

.tree-box{
  background:#fff;
  padding:20px;
  border-radius:10px;
}

.tree-item{
  width:100%;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:10px 0;
}

.left{
  width:240px;
  display:flex;
  align-items:center;
}

.icon{
  width:40px;
  height:40px;
  border-radius:6px;
  margin-right:10px;
  object-fit:cover;
}

.title{
  font-size:15px;
  font-weight:bold;
}

.center{
  flex:1;
  padding:0 20px;
}

.progress-item{
  display:flex;
  align-items:center;
  margin-bottom:8px;
}

.progress-item span{
  width:50px;
}

.right{
  width:120px;
  text-align:right;
}

</style>


// WEBPACK FOOTER //
// src/components/main/aatongji.vue